import React from "react";
import { StyleSheet, View, Text } from "react-native";
import { PaymentIcon } from "react-native-payment-icons";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import * as Colors from "../styles/colors"

export default function PayIcon({ item, showHint = true }) {
    let type = ""
    let color = Colors.BLACK
    let hasIcon = false
    switch (item.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase()) {
        case "american express":
            type = "amex"
            break
        // case "debito":
        //     type = "card-outline"
        //     hasIcon = true
        //     break
        case "pix":
            break
        case "dinheiro":
            type = "cash"
            hasIcon = true
            color = Colors.CASH
            break
        default:
            type = item.toLowerCase()
    }
    return (
        hasIcon ?
            <View style={styles.viewPayment} key={type}>
                <Icon size={50} name={type} style={styles.iconStyle} color={color} />
                <Text style={styles.textPayment}>{item}</Text>
            </View>
            :
            <View style={[styles.viewPaymentPay, { paddingVertical: showHint ? 8 : 0 }]} key={type}>
                <PaymentIcon width={50} type={type} />
                {showHint ? <Text style={styles.textPayment}>{item}</Text> : null}
            </View>)
}
const styles = StyleSheet.create({
    textPayment: {
        margin: 4
    },
    viewPayment: {
        flexDirection: "row",
        margin: 2,
        alignItems: "center",
    },
    viewPaymentPay: {
        flexDirection: "row",
        margin: 2,
        alignItems: "center",
        // paddingVertical: 8,
    },
    iconStyle: {
        padding: 0,
    }
})